import { NgModule } from '@angular/core';
import { MyAccountStoreModule } from './store/my-account-store.module';

@NgModule({
  imports: [MyAccountStoreModule],
})
export class MyAccountDataAccessModule {}
